export const GET_PRODUCT = "GET_PRODUCT";
export const GET_PRODUCT_ID = "GET_PRODUCT_ID";
export const GET_PRODUCT_FAIL = "GET_PRODUCT_FAIL";
export const GET_PRODUCT_EMPTY = "GET_PRODUCT_EMPTY";
export const CREATE_PRODUCT = "CREATE_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const GET_PRODUCTS = "GET_PRODUCTS";
